{
  "ONBOARDING_NEXT": {
    "GREETING": "Привет, {name}!",
    "SUBTITLE": "Пожалуйста, ознакомьтесь со следующими подробностями",
    "YOUR_DETAILS": "Ваши данные",
    "COMPANY_DETAILS": "Информация о компании",
    "FIELDS": {
      "EMAIL": "Email",
      "YOUR_ROLE": "Ваша роль",
      "WEBSITE": "Сайт",
      "LANGUAGE": "Язык",
      "TIMEZONE": "Часовой пояс",
      "COMPANY_SIZE": "Размер компании",
      "INDUSTRY": "Индустрия",
      "REFERRAL_SOURCE": "Где вы нас нашли?"
    },
    "PLACEHOLDERS": {
      "SELECT_ROLE": "Выберите Вашу роль",
      "ENTER_WEBSITE": "www.example.com",
      "SELECT_LANGUAGE": "Выберите язык",
      "SELECT_TIMEZONE": "Выберите часовой пояс",
      "SELECT_COMPANY_SIZE": "Выбрать размер компании",
      "SELECT_INDUSTRY": "Выберите отрасль",
      "SELECT_REFERRAL_SOURCE": "Выбор источника"
    },
    "EMAIL_VERIFIED": "Email подтверждён",
    "SETTING_UP": "Настройка аккаунта...",
    "CONTINUE": "Продолжить",
    "SAVING": "Сохранение...",
    "VALIDATION_ERROR": "Пожалуйста, заполните все обязательные поля",
    "SUCCESS": "Данные успешно сохранены",
    "ERROR": "Не удалось сохранить детали. Пожалуйста, попробуйте еще раз."
  },
  "ONBOARDING_INBOX_SETUP": {
    "GREETING": "Let's set up a few things",
    "SUBTITLE": "This will give you head-start in your workspace",
    "CONTINUE": "Продолжить",
    "SKIP": "Skip",
    "ERROR": "Что-то пошло не так. Попробуйте еще раз.",
    "WHATSAPP_CONNECTED": "WhatsApp connected successfully",
    "FACEBOOK_CONNECTED": "Facebook connected successfully",
    "CREATED_FOR_YOU": {
      "TITLE": "We've created the following for you",
      "LIVE_CHAT": "Live Chat widget",
      "LIVE_CHAT_DESCRIPTION": "Instant messenger for your website",
      "LIVE_CHAT_STATUS": "Almost done…",
      "LIVE_CHAT_READY": "Готово",
      "HELP_CENTER": "Центр поддержки",
      "HELP_CENTER_DESCRIPTION": "Your digital encyclopedia",
      "HELP_CENTER_GENERATING": "Creating your help center…",
      "HELP_CENTER_ANALYZING_WEBSITE": "Analyzing your website…",
      "HELP_CENTER_SETTING_UP_CATEGORIES": "Setting up categories…",
      "HELP_CENTER_CURATING_ARTICLES": "Curating articles…",
      "HELP_CENTER_ARTICLES": "Created {count} article | Created {count} articles",
      "HELP_CENTER_CATEGORIES": "{count} категория | {count} категории",
      "HELP_CENTER_SUMMARY": "Created {count} article across {categories} | Created {count} articles across {categories}"
    },
    "CHANNELS": {
      "TITLE": "Connect all your conversation channels",
      "HEADER": "We found a few channels you can connect",
      "CONNECT": "Подключить",
      "CONNECTED": "Connected",
      "MORE_CHANNELS_NOTE": "Set up {email} and {voice} channels later inside the app",
      "MORE_CHANNELS_EMAIL": "Email",
      "MORE_CHANNELS_VOICE": "Голосовая связь",
      "VIEW_ALL": "Посмотреть все",
      "GMAIL": "Gmail",
      "OUTLOOK": "Outlook",
      "OTHER_EMAIL": "Other Email Providers"
    },
    "CHANNELS_DIALOG": {
      "TITLE": "Connect all your channels instantly",
      "SUBTITLE": "Manage all of them from one dashboard. You can also set up and edit inboxes later inside the app.",
      "NOTE": "SMS, API, Voice, and other email providers can be set up later from your dashboard.",
      "CONNECT_TITLE": "Connect your {name} account",
      "CONNECT_SUBTITLE": "Fill out these quick details",
      "CONNECT": "Подключить",
      "BACK": "Назад",
      "SETUP_LATER": "Setup later in app",
      "FACEBOOK_SUBTITLE": "Authorize access and choose a Page to connect.",
      "FACEBOOK_LAUNCH": "Continue with Facebook",
      "FACEBOOK_SELECT_PAGE": "Select a Page to connect",
      "FACEBOOK_LOADING": "Loading your Facebook Pages…",
      "FACEBOOK_NO_PAGES": "No connectable Pages found. All your Pages are already connected.",
      "FACEBOOK_ERROR": "Couldn't connect to Facebook. Please try again."
    }
  }
}
